function toggleSpecification(contentId, iconId) {
    // Obtén todos los elementos desplegables
    var allContents = document.querySelectorAll('.specifications-content');
    var allIcons = document.querySelectorAll('.specifications-toggle span');
  
    // Cierra todas las secciones excepto la actual
    allContents.forEach(function(content) {
        if (content.id !== contentId) {
            content.style.display = "none";
        }
    });

    // Restaura los íconos de todas las demás secciones
    allIcons.forEach(function(icon) {
        if (icon.id !== iconId) {
            icon.innerHTML = "+";
        }
    });

    // Alterna el estado de la sección actual
    var content = document.getElementById(contentId);
    var icon = document.getElementById(iconId);

    if (content.style.display === "none") {
        content.style.display = "block";
        icon.innerHTML = "-"; // Cambia el ícono a "-"
    } else {
        content.style.display = "none";
        icon.innerHTML = "+"; // Cambia el ícono a "+"
    }
}
